import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import './RightPaletteMenu.scss';
import SelectionSupplier from '../SelectionSuplier/SelectionSuplier';
import CardMaterial from '../CardMaterial/CardMaterial';
import RightSupplierMenu from '../RightSupplierMenu/RightSupplierMenu';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPriceTexture,
  fetchSpecialTextures,
  fetchTextures,
} from '../../../../store/actions/texture.action';
import { DesignerPageContext } from '../../DesignerPage';
import InfiniteScroll from '../../../../components/common/InfiniteScroll/InfiniteScroll';
import { InsideType } from '../../../../constants/enum';
import SearchComponent from '../../../../components/common/SearchComponent/SearchComponent';
import { openMessageError } from '../../../../components/common/Message/openMessageError';
import {
  closeNotification,
  openNotification,
} from '../../../../components/common/Notification/openNotification';
import {
  checkTextureType,
  getSupplierFromModules,
} from '../../../../utils/modules/ModuleUtils';
import { useTranslation } from 'react-i18next';
import ButtonLink from '../../../../components/common/ButtonLink/ButtonLink';
import { setCurrentSupplier } from '../../../../store/reducers/supplier.reducer';
import { fetchSuppliers } from '../../../../store/actions/supplier.action';
import ButtonTertiarySmall from '../../../../components/common/ButtonTertiary/ButtonTertiarySmall';
import { TabSpecialTexture } from '../TabSpecialTexture/TabSpecialTexture';
import callApi from '../../../../utils/api/callAPI';

const RightPaletteMenu = ({ open, onClose, title }) => {
  const { renderSupplierMenu, renderContent } = open ? RenderContent() : {};

  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-start gap-8">
            <ButtonIconGhostMedium
              icon={<Icon.ICArrowBack />}
              onClick={onClose}
            />
            <span className="text-title-large">{title}</span>
          </div>
        }
        content={renderContent?.()}
      />
      {renderSupplierMenu?.()}
      {/* <RightSupplierMenu
        open={openSupplier}
        onClose={supplier => {
          setOpenSupplier(false);
          if (!supplier && open) onClose?.();
        }}
        type="frame"
      /> */}
    </>
  );
};

export default RightPaletteMenu;

const RenderContent = () => {
  const { selectedModels, selectedModel, sceneManager } =
    useContext(DesignerPageContext);
  const { t } = useTranslation();
  const [texture, setTexture] = useState();
  const [search, setSearch] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState();
  const [supplier, setSupplier] = useState();
  const [textureType, setTextureType] = useState();

  const dispatch = useDispatch();
  const { textures, specialTextures } = useSelector(state => state.texture);
  const {
    suppliers,
    currentSupplier: { frame: supplierId },
  } = useSelector(state => state.supplier);

  const { specialTab, setSpecialTab, renderContent, renderSupplierMenu } =
    TabSpecialTexture({
      supplierId,
      supplier,
      setSupplier,
      suppliers,
      textureType,
      // setOpenSupplier,
      type: 'frame',
      texture,
      setTexture,
    });

  const traverseColorAndTexture = useCallback(
    selectedModel => {
      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      if (modules && selectedModel) {
        let supplierIds = { ...(supplierId ?? {}) };

        const moduleEntries = Array.from(modules.entries());
        const module = moduleEntries?.find(
          ([item, value]) => value.group.uuid === selectedModel?.uuid
        );

        let tempTextureFrame = null;
        let tempTextureDoor = null;
        let tempTextureLouveredWall = null;
        moduleEntries.forEach(([item, value]) => {
          if (value?.textures.get('frame')) {
            tempTextureFrame = value?.textures.get('frame');
          }
          if (
            !value?.textures
              .get('DOOR')
              ?.supplier?.materialType?.toLowerCase()
              ?.includes('acrylic')
          ) {
            tempTextureDoor = value?.textures.get('DOOR');
          }
          if (
            value?.textures.get('VACH-LAM') ||
            value?.textures.get('VACH-TRON') ||
            value?.textures.get('VACH-GUONG')
          ) {
            tempTextureLouveredWall =
              value?.textures.get('VACH-LAM') ??
              value?.textures.get('VACH-TRON') ??
              value?.textures.get('VACH-GUONG');
          }
        });

        if (module) {
          const [item, value] = module;
          const textureFrame = value?.textures.get('frame');

          supplierIds = {
            id:
              textureFrame?.supplier?.id ??
              tempTextureFrame?.supplier?.id ??
              tempTextureDoor?.supplier?.id ??
              tempTextureLouveredWall?.supplier?.id ??
              supplierIds?.id,
            materialType:
              textureFrame?.supplier?.materialType ??
              tempTextureFrame?.supplier?.materialType ??
              tempTextureDoor?.supplier?.materialType ??
              tempTextureLouveredWall?.supplier?.materialType ??
              supplierIds?.materialType,
            special:
              textureFrame?.specialTexture ??
              supplierIds?.special ??
              tempTextureFrame?.specialTexture ??
              tempTextureDoor?.specialTexture ??
              tempTextureLouveredWall?.specialTexture ??
              textureType?.split(',').includes('M'),
          };
          if (supplierIds?.id) {
            dispatch(setCurrentSupplier({ frame: supplierIds }));
          }
          if (textureFrame?.textureId) {
            setTexture({
              materialType: textureFrame.supplier?.name ?? '--',
              name: textureFrame.textureCode ?? t('Not selected'),
              src: textureFrame.textureUrl,
              textureId: textureFrame.textureId,
              // special: specialTexture
            });
          } else {
            setTexture();
          }
        }
      }
    },
    [selectedModel, supplierId, sceneManager, textureType]
  );

  const validateHauThickness = (texturePrice, hauThickness) => {
    if (!texturePrice.some(item => item.thickness === hauThickness * 1000)) {
      closeNotification('texture-tam-hau-error');
      openNotification({
        icon: <Icon.ICWarning />,
        key: 'texture-tam-hau-error',
        title: t('The color code cannot be applied to the back panel!'),
        description: t(
          'Please select a new color code, this color code does not support a thickness of {{x}}mm.',
          { x: 8 }
        ),
        duration: 2,
      });
      return false;
    }
    return true;
  };

  const changeTextureTamHau = useCallback(
    async (texturePrice, item, applyToAll, materialType) => {
      closeNotification('texture-tam-hau-error');
      const textureController = sceneManager.textureController;
      const applyTexture = async ({
        module,
        texture = {
          textureId: item.id,
          textureCode: item.code,
          materialType,
          texturePrice: {
            0.017: texturePrice.find(item => item.thickness === 17)?.price || 0,
            0.008: texturePrice.find(item => item.thickness === 8)?.price || 0,
          },
          no_grain: item.group_name === 'no_grain',
          url: item.image,
          supplier: {
            ...(texturePrice.supplier ?? {}),
            ...(supplierId ?? {}),
            materialType,
            name: item.supplier_name,
            ...(item.supplier ?? {}),
          },
          special: item.special && materialType === 'M',
        },
      }) => {
        return await textureController.changeTextureHau({
          module,
          textureType: 'map',
          texture,
        });
      };

      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      const moduleEntries = Array.from(modules.entries());
      if (applyToAll && selectedModel) {
        const len = moduleEntries?.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            const [key, value] = moduleEntries[i];
            const model = value.group;
            model.updateMatrix();
            model.updateMatrixWorld(true);
            if (
              ['dotke', 'tamopbia'].some(item =>
                value?.moduleType.includes(item)
              )
            )
              continue;
            if (
              validateHauThickness(
                texturePrice,
                value?.formularController?.currentOptions?.DDTHau ?? 0
              )
            ) {
              if (
                ['lower', 'upper', 'ceiling'].some(
                  item =>
                    model?.userData?.moduleType?.includes(item) &&
                    selectedModel?.userData?.moduleType?.includes(item)
                )
              ) {
                await applyTexture({
                  module: value,
                });
              }
            } else {
              console.log(value);
            }
          }
        }
      } else {
        const len = selectedModels.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            const [item, value] = moduleEntries.find(
              ([item, value]) => value.group.uuid === selectedModels[i].uuid
            );
            const model = value;
            if (
              validateHauThickness(
                texturePrice,
                value?.formularController?.currentOptions?.DDTHau ?? 0
              )
            ) {
              await applyTexture({ module: model });
            }
          }
        }
      }
    },
    [sceneManager, selectedModel, supplierId, selectedModels, specialTab]
  );

  const autoApplyVatGiuong = useCallback(
    async ({ module, materialType }) => {
      if (!supplierId?.id) return;

      const res = await callApi({
        endpoint: 'textures/v3/textures',
        method: 'get',
        params: {
          offset: 0,
          limit: 20,
          supplier: supplierId.id,
          price_collection_types: supplierId.materialType,
          code: '101',
        },
      });

      if (!res?.data?.success) return;

      const textureList = res.data?.result?.data ?? [];
      const target = textureList.find(t =>
        t.code?.toLowerCase().includes('sh')
      );
      if (!target?.image) return;

      const priceAction = await dispatch(
        fetchPriceTexture({ catalogId: target.id, type: materialType })
      );
      const priceData = priceAction?.payload?.data;
      if (!priceData) return;

      await sceneManager.textureController.changeTexture({
        module,
        texture: {
          url: target.image,
          textureId: target.id,
          textureCode: 'Màu trắng',
          // textureCode: target.code,
          material: materialType,
          texturePrice: {
            0.017: priceData.find(p => p.thickness === 17)?.price || 0,
            0.008: priceData.find(p => p.thickness === 8)?.price || 0,
          },
          no_grain: target.group_name === 'no_grain',
          supplier: {
            ...(supplierId ?? {}),
            materialType,
            name: target.supplier_name,
            ...(target.supplier ?? {}),
          },
          special: false,
        },
        includeMeshes: ['VAT-GIUONG'],
        excludeMeshes: [],
        excludeMeshTypes: [],
        includeMeshTypes: [],
      });
    },
    [supplierId, sceneManager, dispatch]
  );

  const changeTextureFrame = useCallback(
    async (texturePrice, item, applyToAll, materialType) => {
      if (!texturePrice.some(item => item.thickness === 17)) {
        openNotification({
          key: 'texture-frame-error',
          icon: <Icon.ICWarning />,
          title: t('The color code cannot be applied'),
          description: t(
            'Please select a new color code, this color code does not support a thickness of {{x}}mm.',
            { x: 17 }
          ),

          duration: 2,
        });
        return;
      }
      closeNotification('texture-frame-error');
      const textureController = sceneManager.textureController;
      const applyTexture = async ({
        module,

        texture = {
          textureId: item.id,
          textureCode: item.code,
          material: materialType,
          texturePrice: {
            0.017: texturePrice.find(item => item.thickness === 17)?.price || 0,
            0.008: texturePrice.find(item => item.thickness === 8)?.price || 0,
          },
          no_grain: item.group_name === 'no_grain',
          url: item.image,
          supplier: {
            ...(texturePrice.supplier ?? {}),
            ...(supplierId ?? {}),
            materialType,
            name: item.supplier_name,
            special: specialTab === 'special',
            ...(item.supplier ?? {}),
          },
          special: specialTab === 'special',
        },
        excludeMeshTypes = [InsideType.DOOR, InsideType.DOOR_TEMPLATE],
        excludeMeshes = [
          'MAT-DA',
          'VACH-BEP',
          'RAY',
          'GLASS-PANEL',
          'GUONG',
          'NEM-NGOI',
          'VACH-TRON',
          'KINH-THUY',
          'CHAN-BTD',
          'VACH-GUONG',
          'VACH-LAM',
          'LAM_BASE',
          'LAM_SLAT',
        ],
      }) => {
        const result = await textureController.changeTexture({
          module,
          textureType: 'map',
          texture,
          excludeMeshTypes,
          excludeMeshes,
        });

        if (module.cabinetType === 'bed')
          await autoApplyVatGiuong({ module, materialType });

        return result;
      };

      const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
      const moduleEntries = Array.from(modules.entries());

      if (applyToAll && selectedModel) {
        const len = moduleEntries?.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            const [key, value] = moduleEntries[i];
            const model = value.group;
            if (
              ['lower', 'upper', 'ceiling'].some(
                item =>
                  model?.userData?.moduleType?.includes(item) &&
                  selectedModel?.userData?.moduleType?.includes(item)
              )
            )
              await applyTexture({
                module: value,
              });
          }
        }
      } else {
        const len = selectedModels.length;
        if (len) {
          for (let i = 0; i < len; i++) {
            const model = selectedModels[i];
            const [item, value] =
              moduleEntries?.find(
                ([item, value]) => value.group.uuid === model.uuid
              ) ?? [];
            await applyTexture({ module: value });
          }
        }
      }
    },
    [sceneManager, selectedModel, supplierId, selectedModels, specialTab]
  );

  const handleClick = useCallback(
    async (item, func, applyToAll) => {
      const materialType =
        specialTab === 'special' ? 'M' : supplierId?.materialType;
      // const materialType =
      //   typeMaterial === 'M'
      //     ? 'Melamine-coated MDF'
      //     : typeMaterial === 'L'
      //       ? 'Moisture-resistant MDF'
      //       : typeMaterial;
      if (item.image) {
        dispatch(
          fetchPriceTexture({
            catalogId: item.id,
            type: materialType,
          })
        ).then(async action => {
          if (action.payload.data) {
            const { data } = action.payload;
            await changeTextureFrame(data, item, applyToAll, materialType);
            await changeTextureTamHau(data, item, applyToAll, materialType);

            const result = await sceneManager.calculateTotalCost({});
            traverseColorAndTexture(selectedModel);
            func();
          }
        });
      } else {
        openMessageError({
          content: t('The texture has no data, please select another texture.'),
        });
      }
    },
    [
      supplierId,
      changeTextureFrame,
      changeTextureTamHau,
      sceneManager,
      traverseColorAndTexture,
      selectedModel,
      specialTab,
    ]
  );

  const loadMoreData = useCallback(async () => {
    const {
      preParams: { offset, limit },
    } = textures;
    try {
      if (supplierId)
        dispatch(
          fetchTextures({
            offset: (offset ?? 0) + (limit ?? 0),
            limit: limit ?? 20,
            supplier: supplierId.id,
            priceCollectionTypes: supplierId?.materialType,
            kw: debouncedSearch,
          })
        ).then(action => {
          // setLoading(false);
        });
    } catch (e) {
      openMessageError({ content: t('Failed to load texture data.') });
      // setLoading(false);
    }
  }, [supplierId, debouncedSearch, textures]);

  // Debounce searchTerm
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500); // Đợi 500ms sau khi user ngừng gõ

    // Cleanup: Clear timer nếu user gõ tiếp
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    // loadMoreData();
    if (supplierId && specialTab === 'normal') {
      const {
        preParams: { supplier, priceCollectionTypes, kw },
      } = textures;
      if (
        supplier !== supplierId?.id ||
        supplierId?.materialType !== priceCollectionTypes ||
        kw !== debouncedSearch
      )
        if (supplierId) {
          dispatch(
            fetchTextures({
              offset: 0,
              limit: 20,
              supplier: supplierId?.id,
              priceCollectionTypes: supplierId?.materialType,
              kw:
                debouncedSearch?.trim() === ''
                  ? undefined
                  : debouncedSearch?.trim(),
            })
          );
        }
    }
  }, [debouncedSearch, supplierId, specialTab]);

  useEffect(() => {
    if (selectedModel) {
      traverseColorAndTexture(selectedModel);
      setTextureType(checkTextureType(selectedModels, 'frame'));
    }
  }, [selectedModel]);

  return {
    renderSupplierMenu: renderSupplierMenu,
    renderContent: () => (
      <>
        <div
          key={1}
          className="flex p-[16px] flex-col items-end gap-[8px] self-stretch bg-fills-white"
        >
          {/* <TabSpecialTexture id={"frame"} type={"frame"} supplier={supplier} setSupplier={setSupplier} supplierId={supplierId} suppliers={suppliers} textureType={textureType} setOpenSupplier={setOpenSupplier} /> */}
          {renderContent()}

          <div className="flex justify-center items-center self-stretch gap-[4px]">
            <SearchComponent
              size="small"
              styles={{ input: { width: '180px' } }}
              value={search}
              setValue={setSearch}
            />
            {(() => {
              if (supplier?.address) {
                return (
                  <ButtonLink
                    title={<span style={{ color: '#258FD2' }}>Catalog</span>}
                    icon={
                      <span
                        className="w-14 h-14 flex"
                        style={{ color: '#258FD2' }}
                      >
                        <Icon.ICOpenNewTab />
                      </span>
                    }
                    onClick={() => {
                      window.open(supplier.url, '_blank');
                    }}
                  />
                );
              }
            })()}
          </div>
        </div>

        <div
          key={4}
          className="flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
          style={{ backgroundColor: '#F7F7F7' }}
        >
          <div
            id="right-palete-menu"
            className="flex flex-col self-stretch grow overflow-scroll"
          >
            {specialTab === 'special' ? (
              <InfiniteScroll
                dataLength={specialTextures.data.length}
                next={loadMoreData}
                hasMore={specialTextures.data.length < specialTextures.total}
                scrollableTarget={'right-palete-menu'}
                className="flex flex-row flex-wrap gap-2"
              >
                {specialTextures.data.map((item, index) => {
                  return (
                    <CardMaterial
                      key={item.id}
                      item={{
                        title: item.code,
                        description:
                          item.price_group_name ?? item.supplier_name,
                        src: item.icon,
                        detailLink: item.detail_link,
                        productDemo: item.product_demo,
                      }}
                      active={texture && item.id === texture.textureId}
                      onClick={async (func, applyToAll) =>
                        await handleClick(item, func, applyToAll)
                      }
                    />
                  );
                })}
              </InfiniteScroll>
            ) : null}
            {specialTab === 'normal' ? (
              <InfiniteScroll
                dataLength={textures.data.length}
                next={loadMoreData}
                hasMore={textures.data.length < textures.total}
                scrollableTarget={'right-palete-menu'}
                className="flex flex-row flex-wrap gap-2"
              >
                {textures.data.map((item, index) => {
                  return (
                    <CardMaterial
                      key={item.id}
                      item={{
                        title: item.code,
                        description:
                          item.price_group_name ?? item.supplier_name,
                        src: item.icon,
                      }}
                      active={texture && item.id === texture.textureId}
                      onClick={async (func, applyToAll) =>
                        await handleClick(item, func, applyToAll)
                      }
                    />
                  );
                })}
              </InfiniteScroll>
            ) : null}
          </div>
        </div>
      </>
    ),
  };
};
